module.exports = __webpack_public_path__ + "img/qkw_hdz.f814e148.gif";